import React from 'react';

interface OQ45DeletionMessageProps {
    targetName: string;
    oqUsername?: string;
    personId?: string | number;
    portalUrl?: string;
}

const OQ45DeletionMessage = ({ targetName, oqUsername, personId, portalUrl }: OQ45DeletionMessageProps): JSX.Element => (
    <div>
        <p className="mb-3">
            OQ Analyst has no API to delete clinician accounts, so this must be done in two steps.
        </p>
        <p className="mb-2"><strong>Step 1 — Delete in the OQ Analyst portal</strong></p>
        <ul className="mb-3">
            <li>Sign in to the OQ Analyst portal{portalUrl ? <> (<a href={portalUrl} target="_blank" rel="noopener noreferrer">open portal</a>)</> : null} and delete {targetName}&apos;s employee account.</li>
            {oqUsername ? <li>OQ username: <code>{oqUsername}</code></li> : null}
            {personId != null ? <li>OQ person ID: <code>{personId}</code></li> : null}
        </ul>
        <p className="mb-2"><strong>Step 2 — Verify &amp; unlink</strong></p>
        <p className="mb-3">
            Once you&apos;ve deleted it there, click <strong>Verify</strong>. We&apos;ll confirm the account is gone in OQ Analyst,
            then remove the link in MTC. We will <strong>not</strong> change {targetName}&apos;s MTC profile, clinical records, or enrollments.
        </p>
    </div>
);

export default OQ45DeletionMessage;
